import * as React from 'react';
import { useState } from 'react';
import * as ContractRepository from "../../../Repository/ContractRepository";
import { Contract, Tree, User } from "tree-wallet-client";
import { Button } from "antd";
import { isAllowed } from "../../../Service/AuthService";
import { GlobalContext } from '../../../Contexts/GlobalContext';
import MapPopupValidationForm from './MapPopupValidationForm';

interface MapPopupValidateButtonProps {
  setIsValidated: Function;
  isAdmin: boolean;
  language: string;
  tree: Tree;
  user: User;
  contract: Contract;
  updateState: Function;
  onPhotoCapture: (url?: string) => void;
  onValidationSuccess?: () => void;
  setValidationInProgress?: (inProgress: boolean) => void;
  /** When delete confirmation is open, nothing else in the row may be used. */
  deleteBusy?: boolean;
}

export default function MapPopupValidateButton(props: MapPopupValidateButtonProps) {
  const { tree, isAdmin, language, setIsValidated, user: propUser, contract: propContract, updateState, onPhotoCapture, onValidationSuccess, setValidationInProgress, deleteBusy } = props;
  const { user: contextUser, contract: contextContract } = React.useContext(GlobalContext);
  const user = propUser || contextUser;
  const contract = propContract || contextContract;

  const [showForm, setShowForm] = useState<boolean>(false);
  // A tree can carry several validations, so an already validated one keeps its Validate button: `isValidated`
  // deliberately plays no part here.
  const shouldDisplayValidateButton = () => {
    if (isAdmin) {
      return true;
    }

    return user
      && contract
      && isAllowed(contract.roles, [ContractRepository.roles.Validator]);
  }

  if (!shouldDisplayValidateButton()) {
    return <></>
  }

  if (showForm) {
    return (
      <MapPopupValidationForm
        tree={tree}
        user={user}
        contract={contract}
        language={language}
        updateState={updateState}
        onPhotoCapture={onPhotoCapture}
        onCancel={() => {
          setShowForm(false);
          setValidationInProgress?.(false);
          onPhotoCapture(undefined); // Clear preview image on cancel
        }}
        onSuccess={() => {
          setIsValidated(true);
          setShowForm(false);
          setValidationInProgress?.(false);
          onPhotoCapture(undefined); // Clear preview image on success
          onValidationSuccess?.(); // Call parent callback to refresh tree data
        }}
        onValidationStart={() => setValidationInProgress?.(true)}
      />
    );
  }

  return <Button type="primary" className="btn-validate" disabled={deleteBusy} onClick={() => {
    setShowForm(true);
    setValidationInProgress?.(true);
  }}>
    Validate
  </Button>
}